// extracted by mini-css-extract-plugin
module.exports = {"customTooltip":"CustomTooltip_customTooltip__P2n4d","label":"CustomTooltip_label__tJtzz","tooltipDetails":"CustomTooltip_tooltipDetails__YrioV"};